import { isWiseUiEnabled } from 'config/wiseUi';

import LegacyHomeArticlesGroup from './HomeArticlesGroup';
import WiseHomeArticlesGroup from 'components/wise/WiseHomeArticlesGroup/WiseHomeArticlesGroup';

const HomeArticlesGroup = isWiseUiEnabled() ? WiseHomeArticlesGroup : LegacyHomeArticlesGroup;

export default HomeArticlesGroup;
